import axios from 'axios';
import { UserRegistrationForm } from '../models/userModel';

const loadAbort = () => {
    return new AbortController();
};

export const createUserEndpoint = (
    form: UserRegistrationForm,
    token: string = '',
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'post',
                url: `${urlService}/user/v1/admin/developer`,
                data: JSON.stringify(form),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const getUsersOfDeveloperEndpoint = (developerId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/pre-sales/v1/admin/developers/${developerId}/users`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const assignUserToDeveloperEndpoint = (
    developerId: string,
    userId: string,
    token: string,
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'post',
                url: `${urlService}/pre-sales/v1/admin/developers/${developerId}/users`,
                data: JSON.stringify({ userId }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const updateUserPasswordEndpoint = (
    userId: string,
    newPassword: string,
    token: string,
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/developer/${userId}/regenerate-password`,
                data: JSON.stringify({ password: newPassword }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const userDeactivateEndpoint = (userId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'delete',
                url: `${urlService}/user/v1/admin/developer/${userId}/deactivate`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const userActivateEndpoint = (userId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/developer/${userId}/activate`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}
